import { useDisclosure } from '@chakra-ui/react'
import { createContext, useContext, useState } from 'react'

import { TicketEvaluationModalData } from '@/modules/tickets/domain/models/TicketEvaluations'

import CreateTicketEvaluationModal from '../modules/operational/views/UserTicket/CreateTicketEvaluationModal'

const ticketEvaluationContext = createContext<{
  onOpen: (ticketId: string, data: TicketEvaluationModalData) => void
}>({
  onOpen: () => {}
})

export const useTicketEvaluationContext = () =>
  useContext(ticketEvaluationContext)

export default function TicketEvaluationProvider({
  children
}: {
  children: React.ReactNode
}) {
  const [ticketId, setTicketId] = useState<string>('')
  const [evaluationModalData, setEvaluationModalData] =
    useState<TicketEvaluationModalData>()

  const {
    isOpen: isTicketEvaluationOpen,
    onOpen: onTicketEvaluationOpen,
    onClose: onTicketEvaluationClose
  } = useDisclosure()

  return (
    <ticketEvaluationContext.Provider
      value={{
        onOpen: (ticketId: string, data: TicketEvaluationModalData) => {
          setEvaluationModalData(data)
          setTicketId(ticketId)

          onTicketEvaluationOpen()
        }
      }}
    >
      {children}
      {isTicketEvaluationOpen && evaluationModalData && (
        <CreateTicketEvaluationModal
          ticketId={ticketId}
          data={evaluationModalData}
          onClose={onTicketEvaluationClose}
        />
      )}
    </ticketEvaluationContext.Provider>
  )
}
